
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import RecruitmentHero from '@/components/recruitment/RecruitmentHero';
import WhyJoinUs from '@/components/recruitment/WhyJoinUs';
import JobOffers from '@/components/recruitment/JobOffers';
import ApplicationForm from '@/components/recruitment/ApplicationForm';
import SEO from '@/components/SEO';

const Recrutement = () => {
  return (
    <>
      <SEO
        title="Recrutement - Rejoignez Groupe Fabre Environnement"
        description="Découvrez nos offres d'emploi et rejoignez une équipe passionnée par l'environnement. Groupe Fabre Environnement recrute des talents dans le recyclage et la valorisation des déchets."
        canonical="/recrutement"
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main className="pt-16">
          <RecruitmentHero />
          <WhyJoinUs />
          <JobOffers />
          <ApplicationForm />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Recrutement;
